<template>
    <section class="grid-flex column">
      <!-- filters -->
      <div class="flex-1 w100">
        <div class="flex row middle">
          <div class="flex-1 w100">
            <div class="flex end filters-group-holder row">
              <div v-if="false" class="filter-item">
                <label>Moeda</label>
                <select class="input" v-model="filters.data.currency">
                  <option v-for="(c, index) in filters.list.listCurrency" :key="index" :value="c.value" :selected="c.value === filters.data.currency">
                    {{ c.label }}
                  </option>
                </select>
              </div>

              <div style="margin-right: 16px;" class="flex column no-mobile">
                <label>Atualizar dados</label>
                <div class="flex end w100" style="margin-top:12px">
                  <div @click="forceRefreshData()" class="button secondary">
                    <i class="fas fa-sync-alt"></i>
                  </div>
                </div>
              </div>

              <ltk-date-picker
                style="margin-right: 16px;"
                label="Filtro de data"
                v-model="filters.data.date"
                :loading="loading"
              ></ltk-date-picker>

              <ltk-date-picker
                label="Comparar com"
                v-model="filters.data.date2"
                :loading="loading"
              ></ltk-date-picker>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading" class="w100">

        <div class="flex w100">
          <!-- VENDAS -->
          <div class="flex-1 w100">
            <div class="box margin-top-l">
              <div class="box-content ">
                <div class="">
                  <p>
                    LUCRO 
                    <span>
                    ({{ calMediaValue(chartPROFIT.data.datasets) | money }})
                    <span v-html="calDiffPercent(calMediaValue(chartPROFIT.data.datasets), calMediaValue(chartPROFIT.data.datasets, 1))"></span>
                  </span>
                </p>
                </div>
                <line-chart
                  v-if="
                    chartPROFIT.data.datasets &&
                      chartPROFIT.data.datasets.length > 0
                  "
                  class="margin-top-l"
                  :height="140"
                  :chartData="chartPROFIT.data"
                  :options="chartPROFIT.options"
                  :limit="30"
                  color="green"
                ></line-chart>
              </div>
            </div>
          </div>
          <!-- CPA RATE -->
          <div class="flex-1 w100 margin-left">
            <div class="box margin-top-l ">
              <div class="box-content ">
                <div class="">
                  <p>
                    LUCRO ACUMULADO
                    <span>
                      ({{ lastValueDataset(chartPROFITAC.data.datasets) | money }})
                      <span v-html="calDiffPercent(lastValueDataset(chartPROFITAC.data.datasets), lastValueDataset(chartPROFITAC.data.datasets, 1))"></span>
                    </span>
                  </p>
                </div>
                <line-chart
                  v-if="
                    chartPROFITAC.data.datasets &&
                      chartPROFITAC.data.datasets.length > 0
                  "
                  class="margin-top-l"
                  :height="140"
                  :chartData="chartPROFITAC.data"
                  :options="chartPROFITAC.options"
                  :limit="30"
                  color="green"
                ></line-chart>
              </div>
            </div>
          </div>
        </div>

        <div class="flex w100">
          <!-- VENDAS -->
          <div class="flex-1 w100">
            <div class="box margin-top-l">
              <div class="box-content ">
                <div class="">
                  <p>
                    VENDAS 
                    <span>
                    ({{ calMediaValue(chartSALE.data.datasets) | number }})
                    <span v-html="calDiffPercent(calMediaValue(chartSALE.data.datasets), calMediaValue(chartSALE.data.datasets, 1))"></span>
                  </span>
                </p>
                </div>
                <line-chart
                  v-if="
                    chartSALE.data.datasets &&
                      chartSALE.data.datasets.length > 0
                  "
                  class="margin-top-l"
                  :height="140"
                  :chartData="chartSALE.data"
                  :options="chartSALE.options"
                  :limit="30"
                  color="green"
                ></line-chart>
              </div>
            </div>
          </div>
          <!-- CPA RATE -->
          <div class="flex-1 w100 margin-left">
            <div class="box margin-top-l ">
              <div class="box-content ">
                <div class="">
                  <p>
                    VENDAS ACUMULADAS
                    <span>
                      ({{ lastValueDataset(chartSALEAC.data.datasets) | number }})
                      <span v-html="calDiffPercent(lastValueDataset(chartSALEAC.data.datasets), lastValueDataset(chartSALEAC.data.datasets, 1))"></span>
                    </span>
                  </p>
                </div>
                <line-chart
                  v-if="
                    chartSALEAC.data.datasets &&
                      chartSALEAC.data.datasets.length > 0
                  "
                  class="margin-top-l"
                  :height="140"
                  :chartData="chartSALEAC.data"
                  :options="chartSALEAC.options"
                  :limit="30"
                  color="green"
                ></line-chart>
              </div>
            </div>
          </div>
        </div>

        <div class="flex w100">
          <!-- VENDAS -->
          <div class="flex-1 w100">
            <div class="box margin-top-l">
              <div class="box-content ">
                <div class="">
                  <p>
                    VENDAS
                    <span>
                    ({{ calMediaValue(chartSALEMONEY.data.datasets) | money }})
                    <span v-html="calDiffPercent(calMediaValue(chartSALEMONEY.data.datasets), calMediaValue(chartSALEMONEY.data.datasets, 1))"></span>
                  </span>
                </p>
                </div>
                <line-chart
                  v-if="
                    chartSALEMONEY.data.datasets &&
                      chartSALEMONEY.data.datasets.length > 0
                  "
                  class="margin-top-l"
                  :height="140"
                  :chartData="chartSALEMONEY.data"
                  :options="chartSALEMONEY.options"
                  :limit="30"
                  color="green"
                ></line-chart>
              </div>
            </div>
          </div>
          <!-- CPA RATE -->
          <div class="flex-1 w100 margin-left">
            <div class="box margin-top-l ">
              <div class="box-content ">
                <div class="">
                  <p>
                    VENDAS ACUMULADAS
                    <span>
                      ({{ lastValueDataset(chartSALEMONEYAC.data.datasets) | money }})
                      <span v-html="calDiffPercent(lastValueDataset(chartSALEMONEYAC.data.datasets), lastValueDataset(chartSALEMONEYAC.data.datasets, 1))"></span>
                    </span>
                  </p>
                </div>
                <line-chart
                  v-if="
                    chartSALEMONEYAC.data.datasets &&
                      chartSALEMONEYAC.data.datasets.length > 0
                  "
                  class="margin-top-l"
                  :height="140"
                  :chartData="chartSALEMONEYAC.data"
                  :options="chartSALEMONEYAC.options"
                  :limit="30"
                  color="green"
                ></line-chart>
              </div>
            </div>
          </div>
        </div>

        <div class="flex w100">
          <!-- VENDAS -->
          <div class="flex-1 w100">
            <div class="box margin-top-l">
              <div class="box-content ">
                <div class="">
                  <p>
                    Marketing 
                    <span>
                    ({{ calMediaValue(chartMKT.data.datasets) | money }})
                    <span v-html="calDiffPercent(calMediaValue(chartMKT.data.datasets), calMediaValue(chartMKT.data.datasets, 1))"></span>
                  </span>
                </p>
                </div>
                <line-chart
                  v-if="
                    chartMKT.data.datasets &&
                      chartMKT.data.datasets.length > 0
                  "
                  class="margin-top-l"
                  :height="140"
                  :chartData="chartMKT.data"
                  :options="chartMKT.options"
                  :limit="30"
                  color="green"
                ></line-chart>
              </div>
            </div>
          </div>
          <!-- CPA RATE -->
          <div class="flex-1 w100 margin-left">
            <div class="box margin-top-l ">
              <div class="box-content ">
                <div class="">
                  <p>
                    Marketing ACUMULADO
                    <span>
                      ({{ lastValueDataset(chartMKTAC.data.datasets) | money }})
                      <span v-html="calDiffPercent(lastValueDataset(chartMKTAC.data.datasets), lastValueDataset(chartMKTAC.data.datasets, 1))"></span>
                    </span>
                  </p>
                </div>
                <line-chart
                  v-if="
                    chartMKTAC.data.datasets &&
                      chartMKTAC.data.datasets.length > 0
                  "
                  class="margin-top-l"
                  :height="140"
                  :chartData="chartMKTAC.data"
                  :options="chartMKTAC.options"
                  :limit="30"
                  color="green"
                ></line-chart>
              </div>
            </div>
          </div>
        </div>

        <div class="flex w100">
          <div class="flex-1 w100 margin-left">
            <div class="box margin-top-l ">
              <div class="box-content ">
                <div class="">
                  <p>
                    TICKET MÉDIO
                    <span>
                      ({{ calMediaValue(chartSALEAVG.data.datasets) | money }})
                      <span v-html="calDiffPercent(calMediaValue(chartSALEAVG.data.datasets), calMediaValue(chartSALEAVG.data.datasets, 1))"></span>
                    </span>
                  </p>
                </div>
                <line-chart
                  v-if="
                    chartSALEAVG.data.datasets &&
                      chartSALEAVG.data.datasets.length > 0
                  "
                  class="margin-top-l"
                  :height="140"
                  :chartData="chartSALEAVG.data"
                  :options="chartSALEAVG.options"
                  :limit="30"
                  color="green"
                ></line-chart>
              </div>
            </div>
          </div>
        </div>


        <div class="flex w100">
          <!-- CPA -->
          <div class="flex-1 w100">
            <div class="box margin-top-l">
              <div class="box-content ">
                <div class="">
                  <p>
                    CPA
                    <span>
                      ({{ calMediaValue(chartCPA.data.datasets) | money }})
                      <span v-html="calDiffPercent(calMediaValue(chartCPA.data.datasets), calMediaValue(chartCPA.data.datasets, 1))"></span>
                    </span>
                  </p>
                </div>
                <line-chart
                  v-if="
                    chartCPA.data.datasets &&
                      chartCPA.data.datasets.length > 0
                  "
                  class="margin-top-l"
                  :height="140"
                  :chartData="chartCPA.data"
                  :options="chartCPA.options"
                  :limit="30"
                  color="green"
                ></line-chart>
              </div>
            </div>
          </div>
          <!-- CPA RATE -->
          <div class="flex-1 w100 margin-left">
            <div class="box margin-top-l ">
              <div class="box-content ">
                <div class="">
                  <p>
                    CPA Tax
                    <span>
                      ({{ calMediaValue(chartCPATAX.data.datasets) | number }}%)
                      <span v-html="calDiffPercent(calMediaValue(chartCPATAX.data.datasets), calMediaValue(chartCPATAX.data.datasets, 1))"></span>
                    </span>
                  </p>
                </div>
                <line-chart
                  v-if="
                    chartCPATAX.data.datasets &&
                      chartCPATAX.data.datasets.length > 0
                  "
                  class="margin-top-l"
                  :height="140"
                  :chartData="chartCPATAX.data"
                  :options="chartCPATAX.options"
                  :limit="30"
                  color="green"
                ></line-chart>
              </div>
            </div>
          </div>
        </div>

        <div class="flex w100">
          <!-- CPM -->
          <div class="flex-1 w100">
            <div class="box margin-top-l">
              <div class="box-content ">
                <div class="">
                  <p>
                    CPM
                    <span>
                      ({{ calMediaValue(chartCPM.data.datasets) | money }})
                      <span v-html="calDiffPercent(calMediaValue(chartCPM.data.datasets), calMediaValue(chartCPM.data.datasets, 1))"></span>
                    </span>
                  </p>
                </div>
                <line-chart
                  v-if="
                    chartCPM.data.datasets &&
                      chartCPM.data.datasets.length > 0
                  "
                  class="margin-top-l"
                  :height="140"
                  :chartData="chartCPM.data"
                  :options="chartCPM.options"
                  :limit="30"
                  color="green"
                ></line-chart>
              </div>
            </div>
          </div>
          <!-- CTR -->
          <div class="flex-1 w100 margin-left">
            <div class="box margin-top-l">
              <div class="box-content ">
                <div class="">
                  <p>
                    Conversão P. Tax
                    <span>
                      ({{ calMediaValue(chartCONV.data.datasets) | number }}%)
                      <span v-html="calDiffPercent(calMediaValue(chartCONV.data.datasets), calMediaValue(chartCONV.data.datasets, 1))"></span>
                    </span>
                  </p>
                </div>
                <line-chart
                  v-if="
                    chartCONV.data.datasets &&
                      chartCONV.data.datasets.length > 0
                  "
                  class="margin-top-l"
                  :height="140"
                  :chartData="chartCONV.data"
                  :options="chartCONV.options"
                  :limit="30"
                  color="green"
                ></line-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="loading" class="flex w100">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>

    </section>
</template>

<script>

import { getInsight } from "@/services/insight";

import lineChart from "@/components/charts/lineChart";
// import boxInfo from "@/components/boxInfo/BoxInfo";
import ltkDatePicker from "@/components/datepicker/LtkDatePicker";

import moment from "moment";
moment.locale("pt-br");

import { mapState } from "vuex";

const emptyData = {
  profit: "-",
  sales: "-",
  receita_bruta: "-",
  receita_liquida: "-",
  cost_product: "-",
  cost_marketing: "-",
  cost_tax_and_impost: "-",
  conv_billet: "-",
  avg_ticket: "-",
  percent_profit: "-",
  cpa: "-",
  roi: "-",
  approved_sales_count: "-",
  approved_sales_sum: "-",
  await_payment_sales_count: "-",
  await_payment_sales_sum: "-",
  sum_commission_dollar: "-",
  sum_dollar: "-",
};

export default {
  name: "insight",
  components: {
    lineChart,
    ltkDatePicker,
    // boxInfo,
  },
  data() {
    return {
      loading: false,
      isTvMode: false,
      stats: emptyData,
      refreshTime: 60, // 60s refresh data
      refreshInterval: null,
      filters: {
        data: {
          date: [
            moment()
              .add(-30, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
          date2: [],
          currency: 'BRL',
          sumCostsFixed: true,
        },
        list: {
          listCurrency: [
            {
              value: 'BRL',
              label: 'Real Brasileiro (BRL)'
            },
            {
              value: 'USD',
              label: 'Dólar Americano (USD)'
            }
          ]
        },
      },
      chartSALE: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      chartSALEAC: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      chartSALEMONEY: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      chartSALEMONEYAC: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      chartSALEAVG: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      chartMKTAC: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      chartMKT: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      chartCPA: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      chartCPATAX: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      chartCPM: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      chartCONV: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      chartPROFIT: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      chartPROFITAC: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  watch: {
    "filters.data.date": {
      deep: true,
      handler() {
        this.stats = emptyData;
        this.getReport();
      },
    },
    "filters.data.date2": {
      deep: true,
      handler() {
        this.getReportCompare();
      },
    },
  },
  mounted() {
    this.getReport()

    // this.refreshInterval = setInterval(this.getReport, this.refreshTime * 1000)

  },
  methods: {
    forceRefreshData() {
      this.stats = emptyData;
      this.getReport();
    },
    calMediaValue(data, index) {
      if (!data || data.length === 0) {
        return 0
      }

      if (!index) {
        index = 0
      }

      if (!data[index] || (data[index] && !data[index]['data'])) {
        return 0
      }

      return data[index]['data'].reduce((t, n) => n + t , 0) / data[index]['data'].length
    },
    lastValueDataset(data, index) {
      if (!data || data.length === 0) {
        return 0
      }

      if (!index) {
        index = 0
      }

      if (!data[index] || (data[index] && !data[index]['data'])) {
        return 0
      }

      return data[index]['data'][data[index]['data'].length - 1]
    },
    calDiffPercent(value1, value2) {
      if (!value1 || !value2) {
        return ''
      }

      let calDiff = value1 / value2
      calDiff = (calDiff - 1)  * 100
      calDiff = this.$options.filters.number(calDiff)

      if (value1 > value2) {
        return `<span style="color:green;">${calDiff}%</span>`
      }

      return `<span style="color:red;">${calDiff}%</span>`
    },
    getReportCompare() {
      if (this.loading) {
        return
      }

      this.loading = true;

      const date = this.filters.data.date2;
      
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        currency: this.filters.data.currency,
        sum_costs_fixed: this.filters.data.sumCostsFixed,
      };

      getInsight(params)
        .then((result) => {
          let auxDataset = [];

          // graph sale
          auxDataset = [];

          result.graph_sale_day.data.forEach((d) => {
            auxDataset.push({
              label: `${d.label} (COMP)`,
              data: d.data,
            });
          });
          this.chartSALE.data.datasets.push(auxDataset[0]);

          // graph sale
          auxDataset = [];

          result.graph_sale_ac_day.data.forEach((d) => {
            auxDataset.push({
              label: `${d.label} (COMP)`,
              data: d.data,
            });
          });
          this.chartSALEAC.data.datasets.push(auxDataset[0]);

          // graph sale
          auxDataset = [];

          result.graph_sale_money_day.data.forEach((d) => {
            auxDataset.push({
              label: `${d.label} (COMP)`,
              data: d.data,
            });
          });
          this.chartSALEMONEY.data.datasets.push(auxDataset[0]);

          // graph sale
          auxDataset = [];

          result.graph_sale_money_ac_day.data.forEach((d) => {
            auxDataset.push({
              label: `${d.label} (COMP)`,
              data: d.data,
            });
          });
          this.chartSALEMONEYAC.data.datasets.push(auxDataset[0]);

          // graph sale
          auxDataset = [];

          result.graph_profit_day.data.forEach((d) => {
            auxDataset.push({
              label: `${d.label} (COMP)`,
              data: d.data,
            });
          });
          this.chartPROFIT.data.datasets.push(auxDataset[0]);

          // graph sale
          auxDataset = [];

          result.graph_profit_ac_day.data.forEach((d) => {
            auxDataset.push({
              label: `${d.label} (COMP)`,
              data: d.data,
            });
          });
          this.chartPROFITAC.data.datasets.push(auxDataset[0]);

          // graph sale ticket avg
          auxDataset = [];

          result.graph_sale_avg_day.data.forEach((d) => {
            auxDataset.push({
              label: `${d.label} (COMP)`,
              data: d.data,
            });
          });

          this.chartSALEAVG.data.datasets.push(auxDataset[0]);

          // graph MKT AC
          auxDataset = [];

          result.graph_mkt_ac_day.data.forEach((d) => {
            auxDataset.push({
              label: `${d.label} (COMP)`,
              data: d.data,
            });
          });
          this.chartMKTAC.data.datasets.push(auxDataset[0]);


          // graph MKT
          auxDataset = [];

          result.graph_mkt_day.data.forEach((d) => {
            auxDataset.push({
              label: `${d.label} (COMP)`,
              data: d.data,
            });
          });

          this.chartMKT.data.datasets.push(auxDataset[0]);

          // graph cpa
          auxDataset = [];

          result.graph_cpa_day.data.forEach((d) => {
            auxDataset.push({
              label: `${d.label} (COMP)`,
              data: d.data,
            });
          });

          this.chartCPA.data.datasets.push(auxDataset[0]);
          
          // graph tax cpa
          auxDataset = []
          result.graph_cpa_tax_day.data.forEach((d) => {
            auxDataset.push({
              label: `${d.label} (COMP)`,
              data: d.data,
            });
          });
          this.chartCPATAX.data.datasets.push(auxDataset[0]);

          // graph CPM
          auxDataset = []
          result.graph_cpm_day.data.forEach((d) => {
            auxDataset.push({
              label: `${d.label} (COMP)`,
              data: d.data,
            });
          });
          this.chartCPM.data.datasets.push(auxDataset[0]);

          // graph Conver page
          auxDataset = []
          result.graph_conv_day.data.forEach((d) => {
            auxDataset.push({
              label: `${d.label} (COMP)`,
              data: d.data,
            });
          });
          this.chartCONV.data.datasets.push(auxDataset[0]);



        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }

          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar dados",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getReport() {
      if (this.loading) {
        return
      }

      this.loading = true;

      const date = this.filters.data.date;
      
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        currency: this.filters.data.currency,
        sum_costs_fixed: this.filters.data.sumCostsFixed,
      };

      getInsight(params)
        .then((result) => {
          this.stats = result.stats;

          this.chartDataPolar = result.bar_line;
          let auxDataset = [];

          // graph profit
          this.chartPROFIT.data.labels = result.graph_profit_day.labels;
          auxDataset = [];

          result.graph_profit_day.data.forEach((d) => {
            auxDataset.push({
              label: d.label,
              data: d.data,
            });
          });
          this.chartPROFIT.data.datasets = auxDataset;

          // graph profit ac
          this.chartPROFITAC.data.labels = result.graph_profit_ac_day.labels;
          auxDataset = [];

          result.graph_profit_ac_day.data.forEach((d) => {
            auxDataset.push({
              label: d.label,
              data: d.data,
            });
          });
          this.chartPROFITAC.data.datasets = auxDataset;

          // graph sale
          this.chartSALE.data.labels = result.graph_sale_day.labels;
          auxDataset = [];

          result.graph_sale_day.data.forEach((d) => {
            auxDataset.push({
              label: d.label,
              data: d.data,
            });
          });
          this.chartSALE.data.datasets = auxDataset;

          // graph sale ac
          this.chartSALEAC.data.labels = result.graph_sale_ac_day.labels;
          auxDataset = [];

          result.graph_sale_ac_day.data.forEach((d) => {
            auxDataset.push({
              label: d.label,
              data: d.data,
            });
          });
          this.chartSALEAC.data.datasets = auxDataset;

          // graph sale
          this.chartSALEMONEY.data.labels = result.graph_sale_money_day.labels;
          auxDataset = [];

          result.graph_sale_money_day.data.forEach((d) => {
            auxDataset.push({
              label: d.label,
              data: d.data,
            });
          });
          this.chartSALEMONEY.data.datasets = auxDataset;

          // graph sale ac
          this.chartSALEMONEYAC.data.labels = result.graph_sale_money_ac_day.labels;
          auxDataset = [];

          result.graph_sale_money_ac_day.data.forEach((d) => {
            auxDataset.push({
              label: d.label,
              data: d.data,
            });
          });
          this.chartSALEMONEYAC.data.datasets = auxDataset;


          // graph sale ticket avg
          this.chartSALEAVG.data.labels = result.graph_sale_avg_day.labels;
          auxDataset = [];

          result.graph_sale_avg_day.data.forEach((d) => {
            auxDataset.push({
              label: d.label,
              data: d.data,
            });
          });

          this.chartSALEAVG.data.datasets = auxDataset;


          // graph mkt ac
          this.chartMKTAC.data.labels = result.graph_mkt_ac_day.labels;
          auxDataset = [];

          result.graph_mkt_ac_day.data.forEach((d) => {
            auxDataset.push({
              label: d.label,
              data: d.data,
            });
          });
          this.chartMKTAC.data.datasets = auxDataset;


          // graph mkt 
          this.chartMKT.data.labels = result.graph_mkt_day.labels;
          auxDataset = [];

          result.graph_mkt_day.data.forEach((d) => {
            auxDataset.push({
              label: d.label,
              data: d.data,
            });
          });

          this.chartMKT.data.datasets = auxDataset;


          // graph cpa
          this.chartCPA.data.labels = result.graph_cpa_day.labels;
          auxDataset = [];

          result.graph_cpa_day.data.forEach((d) => {
            auxDataset.push({
              label: d.label,
              data: d.data,
            });
          });

          this.chartCPA.data.datasets = auxDataset;
          
          // graph tax cpa
          auxDataset = []
          this.chartCPATAX.data.labels = result.graph_cpa_tax_day.labels;
          result.graph_cpa_tax_day.data.forEach((d) => {
            auxDataset.push({
              label: d.label,
              data: d.data,
            });
          });
          this.chartCPATAX.data.datasets = auxDataset;

          // graph CPM
          auxDataset = []
          this.chartCPM.data.labels = result.graph_cpm_day.labels;
          result.graph_cpm_day.data.forEach((d) => {
            auxDataset.push({
              label: d.label,
              data: d.data,
            });
          });
          this.chartCPM.data.datasets = auxDataset;

          // graph Conver page
          auxDataset = []
          this.chartCONV.data.labels = result.graph_conv_day.labels;
          result.graph_conv_day.data.forEach((d) => {
            auxDataset.push({
              label: d.label,
              data: d.data,
            });
          });
          this.chartCONV.data.datasets = auxDataset;



        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }

          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar dados",
          });
        })
        .finally(() => {
          this.loading = false;
          this.data = emptyData;
        });
    },
  },
}
</script>

<style lang="scss" scoped>

.margin-left {
  margin-left: 8px;
}
</style>
